import React, { useEffect, useState } from 'react'
import { Col, Dropdown, Offcanvas, Row } from 'react-bootstrap';
import { Link, useNavigate, useLocation, matchPath } from 'react-router-dom';
import { useAuth } from '../../context/ContextData';
import ComplaintModal from '../../components/modals/ComplaintModal'
import DealerConnectModal from '../../components/modals/DealerConnectModal';
import DemoModal from '../../components/modals/DemoModal';

const MobFooter = () => {
    const dealerId = localStorage.getItem("dealerId")
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const categories = matchPath("/categories", pathname);
    const search = matchPath("/search", pathname);
    const [parms, setParms] = useState();
    const [demoToast, setDemoToast] = useState(false);
    const { demo, setDealerId } = useAuth();

    useEffect(() => {
        if (categories !== null) {
            setParms(categories.pathname)
        }
        if (search !== null) {
            setParms(search.pathname)
        }
    }, [categories, search]);

    const [showComModal, setShowComModal] = useState(false);
    const [show, setShow] = useState(false);
    const [showSupport, setShowSupport] = useState(false);
    const [delearData, setDelearData] = useState("");
    const [delaerShow, setDelaerShow] = useState(false);
    const [dealerId1, setDealerId1] = useState("")
    const [selectedDealerId, setSelectedDealerId] = useState("")

    const cate = [
        {
            name: 'Wallpapers',
        },
        {
            name: 'PVC Panel',
        },
        {
            name: 'Grass',
        },
        {
            name: 'Flooring',
        },
        {
            name: 'Ceiling',
        },
        {
            name: 'Vertical Garden',
        },
        {
            name: '3D Foam Panel',
        },
    ]
    useEffect(() => {
        if (showSupport === true || dealerId1.length === 10 || selectedDealerId.length === 10) {
            var myHeaders = new Headers();
            myHeaders.append("wu-platform", process.env.REACT_APP_USER_SECRET);
            myHeaders.append("Content-Type", "application/json");

            var raw = JSON.stringify({
                "dealerId": dealerId || dealerId1,
                "selectedDealerId": selectedDealerId
            });

            var requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: raw,
                redirect: 'follow'
            };

            fetch(process.env.REACT_APP_URL + "customer/dealerConnect", requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.status === "success") {

                        // setDelearData(result);
                        setDealerId(result.dealer.dealerId)
                        setSelectedDealerId(result.dealer.dealerId)
                        if (dealerId1) {
                            localStorage.setItem("dealerId", result.dealer.dealerId);
                            localStorage.setItem("storeName", result.dealer.storeName);
                            setDealerId1("");
                            setShow(false)
                        }
                    }
                })
                .catch(error => console.log('error', error));
        }
    }, [showSupport, dealerId, setDealerId, dealerId1, navigate, selectedDealerId]);

    // const pathname = window.location.pathname;

    useEffect(() => {
        if (dealerId && dealerId.length === 10) {
            var myHeaders = new Headers();
            myHeaders.append("wu-platform", process.env.REACT_APP_USER_SECRET);
            myHeaders.append("Content-Type", "application/json");

            var raw = JSON.stringify({
                "dealerId": dealerId
            });

            var requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: raw,
                redirect: 'follow'
            };

            fetch(process.env.REACT_APP_URL + "customer/about", requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.status === "success") {
                        setDelearData({
                            email: result.data.email,
                            mobile: result.data.mobile,
                            whatsapp: result.data.whatsapp,
                            address: result.data.street + ", " + result.data.city + ", " + result.data.state + " - " + result.data.pincode,
                        });
                        if (!localStorage.getItem("dealerId")) {
                            setDealerId(result.data.dealerId)
                            localStorage.setItem("dealerId", result.data.dealerId)
                            localStorage.setItem("storeName", result.data.storeName)
                            navigate(pathname)
                        }
                    }
                })
                .catch(error => console.log('error', error));
        }
    }, [dealerId, setDealerId, navigate, pathname]);

    console.log(delearData);

    return (
        <React.Fragment>
            <ComplaintModal
                show={showComModal}
                closeModal={setShowComModal}
            />
            <DealerConnectModal
                show={delaerShow}
                setShow={setDelaerShow}
            />
            <DemoModal
                show={demoToast}
                setShow={setDemoToast}
            />

            {pathname === parms ? '' :
                <div className="bg-dark text-white mainWidth mb50 pt-2 pb-1 cp">
                    <Row className="mx-0">
                        <Col xs="2 text-start ps-1 pe-0">
                            <Link to="/" className="text-white">
                                <img src={"/assets/images/wallicon_white_logo.png"} alt="Wallicon" className="" width={50} />
                                <div className="fs7">An Interior Tech Company</div>
                            </Link>
                        </Col>
                        <Col xs="3  px-1">
                            <h5 className="fs12 mb-0 cpm">Categories</h5>
                            {cate.map((item, index) =>
                                <div key={index}
                                    onClick={() => {
                                        navigate("/" + item.name.toLowerCase().replace(/\s/g, '-'));
                                        localStorage.setItem("product", item.name);
                                        localStorage.setItem("tabSelection", "style");
                                    }}
                                    className="fs10 mouse"
                                >
                                    {item.name}
                                </div>
                            )}
                        </Col>
                        <Col xs="3  px-0">
                            <h5 className="fs12 mb-0 cpm">Quick Links</h5>
                            <div className="fs10 mouse" onClick={() => {
                                if (demo) {
                                    setDemoToast(true)
                                } else if (!dealerId) {
                                    setDelaerShow(true);
                                } else {
                                    navigate("/about")
                                }
                            }}
                            >About Us</div>
                            <div onClick={() => navigate("/careers")} className="fs10 mouse">Careers</div>
                            <div onClick={() => setShowComModal(true)} className="fs10 mouse">Drop A Complaint</div>
                            <div className="fs10 mouse"> <Link to='/terms' className="text-white text-decoration-none">Terms &amp; Conditions</Link></div>
                            <div className="fs10 mouse"> <Link to='/privacy' className="text-white text-decoration-none">Privacy &amp; Policy</Link></div>
                            <div className="fs10 mouse">Project Gallery</div>
                        </Col>
                        <Col xs="4  px-1">
                            <h5 className="fs12 mb-0 cpm">Follow Us On</h5>
                            <a href="https://www.instagram.com/wallicon_official/" target="_blank" rel="noreferrer">
                                <img src="/assets/icons/instagram_white.svg" alt="Instagram" height="15" width="17" />
                            </a>
                            <a href="https://twitter.com/wallicon2022" target="_blank" rel="noreferrer">
                                <img src="/assets/icons/twitter_white.svg" alt="Twitter" className="ms-3 me-2" height="15" width="17" />
                            </a>
                            <a href="https://www.facebook.com/wallicon2022/" target="_blank" rel="noreferrer">
                                <img src="/assets/icons/facebook_f_white.svg" alt="Facebook" height="15" width="17" />
                            </a>

                            {delearData &&
                                <>
                                    <p className='fs10 mb-0'>
                                        Email: <a href={"mailto:" + delearData.email} className="text-white line-break ">{delearData.email}</a>
                                    </p>
                                    <p className='fs10 mb-0'>
                                        Phone: <a href={"tel:" + delearData.mobile} className="text-white line-break">+91-{delearData.mobile}</a>
                                    </p>
                                    <p className='fs10 mb-0 line-break'>
                                        Address: {delearData.address}
                                    </p>
                                </>
                            }
                        </Col>
                    </Row>
                    <div className="footerBorder text-center w-100 fs10 mt-1 pt-1">
                        <p className="mb-0">&copy; {new Date().getFullYear()} <Link className="text-white" to="/">Wallicon Private Limited.</Link> All Rights Reserved.</p>
                    </div>
                </div>
            }
            {/* -------------------------------Navigation Bar----------------------- */}
            <div className="pfdx wdFooter bottom-0 w-100 bg-white border tw_center">
                <Row className="mx-0 mainWidth py-1 row-cols-5">
                    <Col className="text-center mouse">
                        <img
                            src="/assets/icons/option.svg"
                            alt="options"
                            onClick={() => {
                                show === false ? setShow(true) : setShow(false);
                            }}
                            height="20"
                        />
                        <div className="fs10">Menu</div>
                    </Col>
                    <Col className="text-center mouse">
                        <img
                            src="/assets/icons/category.svg"
                            alt="cata"
                            onClick={() => { navigate("/categories"); setShow(false) }}
                            height="20"
                        />
                        <div className="fs10">Categories</div>
                    </Col>
                    <Col className="text-center mouse">
                        <img
                            src="/assets/icons/home.svg"
                            alt="home"
                            onClick={() => { navigate("/"); setShow(false); }}
                            height="20"
                        />
                        <div className="fs10">Home</div>
                    </Col>
                    <Col className="text-center mouse">
                        <img
                            src="/assets/icons/search.svg"
                            alt="search"
                            height="20"
                            onClick={() => { navigate("/search"); setShow(false); }}
                        // onClick={() => { navigate("/search"); setShow(false); }}
                        // onClick={() => { (!showSearch ? setShowSearch(true) : setShowSearch(false));  setShowCategory(false); setShow(false);  }}
                        />
                        <div className="fs10">Search</div>
                    </Col>
                    <Col className="text-center">
                        {!dealerId ?
                            <Dropdown drop="top" className="btnDrop " onClick={() => {
                                if (demo) {
                                    setDemoToast(true)
                                } else {
                                    setDelaerShow(true);
                                }
                            }}>
                                <Dropdown.Toggle className="w-100 m-0 supportClass" >
                                    <img
                                        src="/assets/icons/support.svg"
                                        alt="support"
                                        height="19"
                                        className=""
                                    />
                                    <div className="fs10 " >Support</div>
                                </Dropdown.Toggle>
                            </Dropdown>
                            :
                            <Dropdown drop="top" className="btnDrop " onClick={() => { setShowSupport(true); }}>
                                <Dropdown.Toggle className="w-100 m-0 supportClass" >
                                    <img
                                        src="/assets/icons/support.svg"
                                        alt="support"
                                        height="19"
                                        className=""
                                    />
                                    <div className="fs10 " >Support</div>
                                </Dropdown.Toggle>

                                <Dropdown.Menu className=" m-0 text-end dropdownMenu border-0 bg-transparent">
                                    <Dropdown.Item
                                        target="_blank"
                                        eventKey="1"
                                        href={"tel:" + delearData.mobile}
                                        className=" bg-transparent p-0 float-end "
                                    >
                                        <img
                                            src="/assets/icons/supportcall.svg"
                                            alt="callblue"
                                            className="m-0 mb-3"
                                        />
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                        target="_blank"
                                        href={`https://wa.me/+91${delearData.whatsapp}`}
                                        eventKey="2"
                                        className=" bg-transparent p-0 float-end"
                                    >
                                        <img
                                            src="/assets/icons/supportwhatsapp.svg"
                                            alt="whatsapp"
                                            className="mouse m-0 mb-2"
                                        />
                                    </Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        }
                    </Col>
                </Row>
            </div>
            <Offcanvas
                show={show}
                onHide={() => setShow(false)}
                className="border1 left_Menu cp "
            >
                <Offcanvas.Body className="px-0">
                    {!dealerId && !demo ?
                        <Row className="mx-0 mb-3">
                            <Col>
                                <div className="fs12 ">
                                    <b>For Customer</b>
                                </div>
                                <input
                                    type="number"
                                    placeholder="ENTER DEALER ID"
                                    className="customerbtn w-100 text-center"
                                    value={dealerId1}
                                    onChange={(e) => setDealerId1(e.target.value)}
                                />
                            </Col>
                            <Col>
                                <div className="fs12">
                                    <b>For Dealership</b>
                                </div>
                                <a target="_blank" rel="noreferrer" href={global.duUrl} className="regbtn" >REGISTER</a>
                            </Col>
                        </Row>
                        : demo ?
                            <div className="tw_center">
                                <Link to="/">
                                    <img src="/wallicon_logo.png" alt="wallicon" height="27" width="47" />
                                </Link>
                                <h5 className="fs_16 pf ls13em headDemobr mt-1"> YOUR COMPNAY NAME </h5>
                            </div>
                            :
                            <div className="tw_center">
                                <Link to="/">
                                    <img src="/wallicon_logo.png" alt="wallicon" height="27" width="47" />
                                </Link>
                                <div className="fs10 pf ls06em">Authorised Dealer</div>
                                <h5 className="fs_16 pf ls13em headDemobr"> {localStorage.getItem("storeName")} </h5>
                            </div>
                    }

                    <div className="px-4 py-2 border-top">
                        <div className="left_Menu_fs cpm mb-3"
                            onClick={() => { navigate("/categories"); setShow(false) }}
                        >Category</div>
                        <div className="left_Menu_fs cpm mb-3"
                            onClick={() => { navigate("/checkout/cart"); setShow(false) }}
                        >Wishlist</div>
                        <div className="left_Menu_fs cpm mb-3"
                            onClick={() => { navigate("/checkout/cart"); setShow(false) }}
                        >Cart</div>
                        <div className="left_Menu_fs cpm mb-3" onClick={() => { navigate("/order"); setShow(false) }}>Orders</div>
                        <div>
                            <div className="fs10  new">New</div>
                            <div className="left_Menu_fs cpm mb-3">Launch</div>
                        </div>
                        <div className="left_Menu_fs cpm mb-3">Expert</div>
                        <div className="left_Menu_fs cpm "
                            onClick={() => {
                                if (demo) {
                                    setDemoToast(true)
                                } else if (!dealerId) {
                                    setDelaerShow(true);
                                } else {
                                    navigate("/about")
                                }
                            }}
                        >About</div>
                    </div>
                    <div className="border-top border-bottom px-4 py-3 ">
                        <div className="left_Menu_fs fs14_color mb-2">Project Gallery</div>
                        <div className="left_Menu_fs fs14_color mb-2 mouse"
                            onClick={() => { setShow(false); setShowComModal(true) }}
                        >Drop a Complaint</div>
                        <div className="left_Menu_fs fs14_color mb-2"
                            onClick={() => navigate("/terms")}
                        >Terms &amp; Conditions</div>
                        <div className="fs12 cpm">Follow Us On:</div>
                        <div className="">
                            <img
                                src="/assets/icons/inxt.png"
                                alt="insta"
                                className="me-3 iocn_Size"
                            />
                            <img
                                src="/assets/icons/fbO.png"
                                alt="facebook"
                                className="ms-2 me-3 iocn_Size"
                            />
                            <img
                                src="/assets/icons/youtube.png"
                                alt="youtube"
                                className="ms-2 me-3 iocn_Size"
                            />
                            <img
                                src="/assets/icons/twit.png"
                                alt="twitter"
                                className="ms-2 me-2 iocn_Size"
                            />
                        </div>
                    </div>
                    <div className="">
                        <div className="align-items-center d-flex ps-4 ">
                            <img src="/assets/icons/phone.png" alt="phone" height="39" />
                            <div>
                                <span className="fs14 cpm ms-2 ">
                                    Enjoy App-Like experiance
                                </span>
                                <br />
                                <span className="fs14 ms-2">Get our web-app.</span>
                            </div>
                        </div>

                        <div className="ms-4 mt-2">
                            <button className="aadbtn cpm">Add to Homescreen</button>
                        </div>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>


        </React.Fragment >
    )
}

export default MobFooter
